import "../../App.css";
import React from "react";
import Service from '../service';
import CONTACT_US from '../footer';
function Service_Page() {
    return(
    <>
        <Service/>
        <CONTACT_US/> 
    </>
    )
}
export default Service_Page;